  document.addEventListener('DOMContentLoaded', function () {
    const homeEssentialCards = document.querySelectorAll('.home-essential-card');
    const homeEssentialDesktopSliders = document.querySelectorAll('.home-essential-desktop-slider');
    const homeEssentialSwiperMap = new Map();

    function initCardImageObserver(scope = document) {
      const images = scope.querySelectorAll('.home-essential-card-img[data-src]');

      if (!('IntersectionObserver' in window)) {
        images.forEach(img => {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
        return;
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            obs.unobserve(img);
          }
        });
      }, {
        rootMargin: '200px',
        threshold: 0.1
      });

      images.forEach(img => observer.observe(img));
    }

    function initHomeEssentialSwiper(sliderWrapper) {
      const sliderEl = sliderWrapper.querySelector('.home-essential-slider');
      if (!sliderEl || homeEssentialSwiperMap.has(sliderEl)) return;

      const swiper = new Swiper(sliderEl, {
        loop: true,
        spaceBetween: 24,
        navigation: {
          nextEl: sliderEl.querySelector('.home-essential-slider-arrow-right'),
          prevEl: sliderEl.querySelector('.home-essential-slider-arrow-left'),
        },
        slidesPerView: 1,
        breakpoints: {
          600: { slidesPerView: 2 },
          1000: { slidesPerView: 2, allowTouchMove: false },
          1199: { slidesPerView: 2.5 },
        },
      });

      homeEssentialSwiperMap.set(sliderEl, swiper);
    }

    initCardImageObserver(document);

    const defaultHomeEssentialCard = document.querySelector('.home-essential-card.home-essential-card-active');
    if (defaultHomeEssentialCard) {
      const index = defaultHomeEssentialCard.dataset.homeEssentialIndex;
      const defaultSlider = document.querySelector(
        `.home-essential-desktop-slider[data-home-essential-index="${index}"]`
      );

      if (defaultSlider) {
        defaultSlider.classList.add('home-essential-desktop-slider-active');
        initHomeEssentialSwiper(defaultSlider);
      }

      const icon = defaultHomeEssentialCard.querySelector('.home-essential-toggle-icon');
      if (icon) {
        icon.src = 'https://cdn.shopify.com/s/files/1/0697/1015/1902/files/dakshin-minus.svg?v=1763549243';
      }
    }

    homeEssentialCards.forEach((card) => {
      card.addEventListener('click', function () {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const index = this.dataset.homeEssentialIndex;

        if (this.classList.contains('home-essential-card-active')) return;

        homeEssentialCards.forEach((c) => {
          c.classList.remove('home-essential-card-active');
          const icon = c.querySelector('.home-essential-toggle-icon');
          if (icon) {
            icon.src =
              'https://cdn.shopify.com/s/files/1/0697/1015/1902/files/add_icon_b5ceb079-29fe-4590-8c59-87fc1887b0b3.png?v=1757581151';
          }
        });

        homeEssentialDesktopSliders.forEach((s) => {
          s.classList.remove('home-essential-desktop-slider-active');
        });

        this.classList.add('home-essential-card-active');
        const activeIcon = this.querySelector('.home-essential-toggle-icon');
        if (activeIcon) {
          activeIcon.src =
            'https://cdn.shopify.com/s/files/1/0697/1015/1902/files/dakshin-minus.svg?v=1763549243';
        }

        const activeSlider = document.querySelector(
          `.home-essential-desktop-slider[data-home-essential-index="${index}"]`
        );
        if (activeSlider && !isMobile) {
          setTimeout(() => {
            activeSlider.classList.add('home-essential-desktop-slider-active');
            initHomeEssentialSwiper(activeSlider);
          }, 50);
        }


        initCardImageObserver(this);

        if (isMobile) {
          setTimeout(() => {
            const headerOffset = 140;
            const elementPosition = this.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }, 300);
        }
      });
    });
  });